/**
 * unitConversion.ts — перевод единиц роста и веса «как у эталона»: одни числа
 * на расчёты тела (`bodyMetrics.ts`, едет отложенным куском) и на правила
 * логики по «Весу» и «Росту» (`logic-engine/answerUnits.ts`, первый экран
 * воронки, WEB-2350). Отдельный модуль без импортов — чтобы первый экран не
 * тянул расчёты тела; `bodyMetrics.ts` отдаёт эти же значения дальше.
 */

/** `orig/utils/unitConversion.ts:14, 18` — фунтов в килограмме при переключении единиц. */
export const SLIMKIT_LB_PER_KG = 2.20462;
/** `orig/utils/unitConversion.ts:2, 10` — сантиметров в дюйме. */
export const CM_PER_INCH = 2.54;

/** Округление «как у эталона»: `Number(x.toFixed(1))` (warningBMIMessage:55, currentBMIV2:175). */
export function roundTo1(value: number): number {
  return Number(value.toFixed(1));
}
